module.exports = __webpack_public_path__ + "fonts/fa-solid-900.0c6bfc66.eot";